"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Timer = /*#__PURE__*/function () {
  function Timer(callback, delay) {
    _classCallCheck(this, Timer);

    this.callback = callback;
    this.timerLength = callback;
    this.timerId = delay;
    this.start = delay;
    this.remaining = delay; // start the timeout on call

    this.resume();
  }

  _createClass(Timer, [{
    key: "resume",
    value: function resume() {
      // When class.resume() is called, start a new timeout with the remaining time left
      this.start = Date.now();
      window.clearTimeout(this.timerId);
      this.timerId = setTimeout(this.callback, this.remaining);
    }
  }, {
    key: "pause",
    value: function pause() {
      // When class.pause() is called, clear the timeout and save the time remaining
      window.clearTimeout(this.timerId);
      this.remaining -= Date.now() - this.start;
    }
  }, {
    key: "clear",
    value: function clear() {
      // When class.clear() is called, the timer is cleared and reset
      window.clearTimeout(this.timerId);
      this.timerId = this.timerLength;
      this.start = this.timerLength;
      this.remaining = this.timerLength;
    }
  }]);

  return Timer;
}();

exports.default = Timer;